import { useState as n, useEffect as C } from "react";
import "./firebase-d0134a8f.js";
import "./@firebase-868b0e52.js";
import "./node-forge-b3503c74.js";
import "./usehooks-ts-53aa4768.js";
import "./myasurion-shared.mixpanel.es.js";
import { b as E } from "./contentful-ed636ee7.js";
const J = (e = {}, r = "", s = "", f = "", i = "", l = {}) => {
  const [c, u] = n([]), [a, o] = n(!1), [m, y] = n(null), p = JSON.stringify(e);
  return C(() => {
    o(!0), (async () => {
      try {
        const t = await E(
          e,
          r,
          s,
          f,
          i,
          l
        );
        u(t);
      } catch (t) {
        y(t);
      } finally {
        o(!1);
      }
    })();
  }, [p]), {
    contentfulEntry: c,
    contentfulEntryLoading: a,
    errors: m
  };
};
export {
  J as u
};
